import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBxSortDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.99992 13.3333L6.66659 10.6666H4.66659V2.66663H3.33325V10.6666H1.33325L3.99992 13.3333ZM7.33325 5.33329H13.3333V6.66663H7.33325V5.33329ZM7.33325 7.99996H11.9999V9.33329H7.33325V7.99996ZM7.33325 2.66663H14.6666V3.99996H7.33325V2.66663ZM7.33325 10.6666H10.6666V12H7.33325V10.6666Z",
		fill: "currentColor"
	})
});
export default SvgBxSortDown;
